
import React from "react"
import { skin } from "config/api"
import { connect } from "react-redux"
import { AuthActions, MainActions } from "redux-store/models"
import {
  subscribeSocketUser,
  subscribeSocketSupport,
} from "config/socket.js"
import { withRouter } from "react-router-dom"
import { Captcha } from "shared-components"
import { notification } from "antd"
import { dontShowRPCH } from "utils/HelperFunc"
import { Button, Form, Input } from "antd"
import { Col, Row } from "antd"
import "./login.css"
import OtpVerification from "./OtpVerification"

class Login extends React.Component {
  state = {
    userName: "",
    password: "",
    email: "",
    isForgot: false,
    captchaToken: false,
    credentials: {
      username: "",
      password: "",
    },
    showOtp: false,
    otp: "",
    otpError: "",
    otpLoading: false,
  }

  handleChangeUsername = (event) => {
    const username = event.target.value

    this.setState({
      userName: username,
      credentials: {
        ...this.state.credentials,
        username,
      },
    })
  }

  handleChangePassword = (event) => {
    const password = event.target.value

    this.setState({
      password,
      credentials: {
        ...this.state.credentials,
        password,
      },
    })
  }

  socketCall = (data) => {
    subscribeSocketUser(data.id, this.props)

    if (data.role.name === "support") {
      subscribeSocketSupport(this.props)
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault()

    const {
      userName,
      password,
      email,
      isForgot,
      captchaToken,
    } = this.state

    if (isForgot) {
      this.props.forgotPassword(email)
      return
    }

    if (
      (captchaToken && captchaToken !== "") ||
      dontShowRPCH(isForgot)
    ) {
      this.props.setOtpInfo(null)

      await this.props.signInByEmail(
        userName,
        password,
        this.socketCall,
        JSON.parse(localStorage.getItem("device_token")),
      )

      return
    }

    notification.error({
      message: "Verifica che non sei un robot (reCAPTCHA)",
      placement: "topRight",
    })
  }

  handleLoginRedirect = () => {
    if (this.props.match.params["link2"]) {
      if (this.props.match.params["link2"] === "linkTo") {
        window.location.hash = `dashboard/ricariche/${this.props.match.params.c1}/${this.props.match.params.c2}`
      } else {
        window.location.hash = `dashboard/${
          this.props.match.params["link2"] || "ricariche"
        }`
      }
    } else {
      window.location.hash = "dashboard/ricariche"
    }
  }

  handleVerifyOtp = () => {
    const { otp, credentials } = this.state

    if (otp.length !== 6) {
      this.setState({
        otpError: "Inserisci il codice OTP a 6 cifre.",
      })

      return
    }

    if (!credentials?.username || !credentials?.password) {
      this.setState({
        otpError: "Credenziali mancanti.",
      })

      return
    }

    this.props.setOtpInfo(null)

    this.setState({
      otpLoading: true,
      otpError: "",
    })

    this.props.signInByEmail(
      credentials.username,
      credentials.password,
      this.socketCall,
      JSON.parse(localStorage.getItem("device_token")),
      otp,
    )
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.otpInfo &&
      this.props.otpInfo !== prevProps.otpInfo &&
      this.props.otpInfo.needs_2fa
    ) {
      this.setState({
        showOtp: true,
        otpLoading: false,
        otpError:
          this.props.otpInfo.message ||
          "Il codice OTP inserito non è corretto.",
      })

      return
    }

    if (
      this.props.accountInfo &&
      this.props.accountInfo !== prevProps.accountInfo
    ) {
      if (this.state.showOtp) {
        this.setState({
          showOtp: false,
          otpLoading: false,
          otp: "",
          otpError: "",
        })

        this.handleLoginRedirect()
      }
    }
  }

  render() {
    const { isForgot, showOtp } = this.state
    const { loginMsg, skinExtras } = this.props

    const isMrPayCard =
      process.env.REACT_APP_IS_MRPAY_CARD === "true"

    const accentColor = isMrPayCard
      ? "#011240"
      : "#7AAD36"

    return (
      <Row type="flex" justify="center" align="middle">
        <Col>
          <div className="login-new animated fadeIn">
            {showOtp ? (
              <>
                <h6 style={{ color: accentColor }}>
                  Verifica a due fattori
                </h6>

                <OtpVerification
                  value={this.state.otp}
                  error={this.state.otpError}
                  loading={this.state.otpLoading}
                  onChange={(otp) =>
                    this.setState({
                      otp,
                      otpError: "",
                    })
                  }
                  onVerify={this.handleVerifyOtp}
                  onBack={() => {
                    this.props.setOtpInfo(null)

                    this.setState({
                      showOtp: false,
                      otp: "",
                      otpError: "",
                      otpLoading: false,
                    })
                  }}
                />
              </>
            ) : (
              <>
                <h6 style={{ color: accentColor }}>
                  {isForgot
                    ? "Recupero credenziali"
                    : "Accedi con le tue credenziali"}
                </h6>

                {loginMsg ? (
                  <div className="loginMsg">{loginMsg}</div>
                ) : (
                  <>
                    {isForgot ? (
                      <p className="login-register">
                        Per recuperare la tua password, inserisci la tua email
                      </p>
                    ) : (
                      <p className="login-register">
                        Non hai un account?{" "}
                        {skin.skin_id === 4 ? (
                          <a href="https://services.planetservizi.it/login#/rut/y6flOjiiBH">
                            <span>REGISTRATI</span>
                          </a>
                        ) : (
                          <span>Registrati</span>
                        )}
                      </p>
                    )}
                  </>
                )}

                <Form
                  name="user_login"
                  className="login-form"
                  layout="vertical"
                >
                  {isForgot ? (
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "Please input your email!",
                        },
                      ]}
                    >
                      <label>Email</label>

                      <Input
                        placeholder="Email"
                        type="email"
                        onChange={(e) =>
                          this.setState({
                            email: e.target.value,
                          })
                        }
                        value={this.state.email}
                      />
                    </Form.Item>
                  ) : (
                    <>
                      <Form.Item
                        name="username"
                        rules={[
                          {
                            required: true,
                            message: "Please input your username!",
                          },
                        ]}
                      >
                        <label>Nome Utente</label>

                        <Input
                          placeholder="Nome Utente"
                          onChange={this.handleChangeUsername}
                          value={this.state.userName}
                        />
                      </Form.Item>

                      <Form.Item
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                        ]}
                      >
                        <label>Password</label>

                        <Input.Password
                          placeholder="Password"
                          value={this.state.password}
                          onChange={this.handleChangePassword}
                        />
                      </Form.Item>
                    </>
                  )}

                  {!dontShowRPCH(isForgot) && (
                    <Captcha
                      onChange={(token) =>
                        this.setState({
                          captchaToken: token,
                        })
                      }
                    />
                  )}

                  <Form.Item>
                    <Button
                      type="primary"
                      block
                      htmlType="submit"
                      onClick={this.handleSubmit}
                      style={{
                        background: accentColor,
                        borderColor: accentColor,
                        marginTop: dontShowRPCH(isForgot)
                          ? "0"
                          : "30px",
                      }}
                    >
                      {isForgot ? "VAI" : "Log in"}
                    </Button>
                  </Form.Item>
                </Form>

                <p
                  className="forgot-pass"
                  style={{ color: accentColor }}
                  onClick={() =>
                    this.setState({
                      isForgot: !isForgot,
                    })
                  }
                >
                  {!isForgot
                    ? "Hai dimenticata il tuo password?"
                    : "Login"}
                </p>
              </>
            )}
          </div>
        </Col>

        <div
          className="login-page-footer"
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            color: "#fff",
            textAlign: "center",
            padding: "10px 20px",
            maxWidth: "600px",
            margin: "0 auto",
            zIndex: 2,
          }}
        >
          <div
            className="privacy"
            style={{
              paddingBottom: 20,
            }}
          >
            <a
              style={{
                color: "#fff",
                backgroundImage: `linear-gradient(
                  to right,
                  ${accentColor},
                  ${accentColor} 50%,
                  #fff 50%
                )`,
              }}
            >
              Privacy Notice
            </a>

            <div className="vl" />

            <a
              style={{
                color: "#fff",
                backgroundImage: `linear-gradient(
                  to right,
                  ${accentColor},
                  ${accentColor} 50%,
                  #fff 50%
                )`,
              }}
            >
              Cookies Notice
            </a>

            <div className="vl" />

            <a
              style={{
                color: "#fff",
                backgroundImage: `linear-gradient(
                  to right,
                  ${accentColor},
                  ${accentColor} 50%,
                  #fff 50%
                )`,
              }}
            >
              Cookies Settings
            </a>
          </div>

          <div className="copyright">
            Copyright © {new Date().getFullYear()} {skinExtras.name}. All
            rights reserved. {skinExtras.name}® is a registered trademark.
          </div>
        </div>
      </Row>
    )
  }
}

const mapsStateToProps = (state) => ({
  loginMsg: state.auth.loginMsg,
  otpInfo: state.auth.otpInfo,
  skinExtras: state.auth.skinExtras,
  accountInfo: state.auth.accountInfo,
})

export default withRouter(
  connect(mapsStateToProps, {
    ...AuthActions,
    ...MainActions,
  })(Login),
)

